import { render, staticRenderFns } from "./SmallLoader.vue?vue&type=template&id=c2505ea0&scoped=true"
import script from "./SmallLoader.vue?vue&type=script&lang=js"
export * from "./SmallLoader.vue?vue&type=script&lang=js"
import style0 from "./SmallLoader.vue?vue&type=style&index=0&id=c2505ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2505ea0",
  null
  
)

export default component.exports